import usePastTime from 'hooks/usePastTime';
import PencilIcon from 'icons/Pencil.icon';
import TrashIcon from 'icons/Trash.icon';
import { Button } from 'ncoded-component-library';
import React, { ReactNode, useCallback, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { DataRoomRfiTemplate } from 'router/subrouters/DataRoom/models/DataRoomRfi';
import DataRoomContext from 'router/subrouters/DataRoom/providers/DataRoom/DataRoom.context';
import RfiContext from 'router/subrouters/DataRoom/providers/Rfi/Rfi.context';
import { getDataRoomRoute } from 'utils';

type CellProps = {
  template: DataRoomRfiTemplate;
};

export type TemplateTable = Pick<DataRoomRfiTemplate, 'name' | 'createdAt'> &
  Record<'manage', string>;

export const TABLE_COLUMNS: Array<keyof TemplateTable> = [
  'name',
  'createdAt',
  'manage',
];

export const HEADING_TRANSLATIONS: Record<keyof TemplateTable, string> = {
  name: 'name',
  createdAt: 'createdOn',
  manage: '',
};

export const CUSTOM_COL_SIZES: Partial<
  Record<typeof TABLE_COLUMNS[number], number>
> = {
  name: 400,
  createdAt: 200,
  manage: 100,
};

const NameCell: React.FC<CellProps> = ({ template }) => {
  const { name } = template || {};

  return <p>{name}</p>;
};

const CreateAtCell: React.FC<CellProps> = ({ template }) => {
  const { createdAt } = template || {};

  const date = usePastTime()(createdAt);

  return <p>{date}</p>;
};

const ManageCellComponent: React.FC<CellProps> = ({ template }) => {
  const { _id } = template || {};

  const {
    dataRoom: { _id: dataRoomId },
  } = useContext(DataRoomContext);
  const { deleteTemplate } = useContext(RfiContext);

  const navigate = useNavigate();

  const onEdit = useCallback(
    () =>
      navigate(`${getDataRoomRoute(dataRoomId, 'rfi/edit-template')}/${_id}`),
    [_id, dataRoomId, navigate],
  );

  return (
    <div className="actions">
      <Button variant="icon" icon={PencilIcon} onClick={onEdit} />
      <Button
        variant="icon"
        className="delete"
        icon={TrashIcon}
        onClick={() => deleteTemplate(_id)}
      />
    </div>
  );
};

export const BODY_CONTENT_GENERATE: Record<
  keyof TemplateTable,
  (cellProps: CellProps) => ReactNode
> = {
  name: (cellProps: CellProps) => <NameCell {...cellProps} />,
  createdAt: (cellProps: CellProps) => <CreateAtCell {...cellProps} />,
  manage: (cellProps: CellProps) => <ManageCellComponent {...cellProps} />,
};
